import { Theme } from "@material-ui/core";
import { Overrides } from "@material-ui/core/styles/overrides";
import { MuiPickersOverrides } from "@material-ui/pickers/typings/overrides";
import { action, observable } from "mobx";
import { create, persist } from "mobx-persist";
import { aaaTheme } from "./aaa/aaaTheme";
import { aaaCustomColors } from "./aaa/aaaCustomColors";
import { aaaGlobalCSS } from "./aaa/aaaGlobalCSS";
import { aaaImages } from "./aaa/aaaImages";
import { dalTheme } from "./dal/dalTheme";
import { dalCustomColors } from "./dal/dalCustomColors";
import { dalGlobalCSS } from "./dal/dalGlobalCSS";
import { dalImages } from "./dal/dalImages";
import { aaaImagesDark } from "./aaa/aaaImagesDark";
import { aaaThemeDark } from "./aaa/aaaThemeDark";
import { aaaGlobalCSSDark } from "./aaa/aaaGlobalCSSDark";
import { aaaCustomColorsDark } from "./aaa/aaaCustomColorsDark";
import { dalCustomColorsDark } from "./dal/dalCustomColorsDark";
import { dalGlobalCSSDark } from "./dal/dalGlobalCSSDark";
import { dalImagesDark } from "./dal/dalImagesDark";
import { dalThemeDark } from "./dal/dalThemeDark";

type overridesNameToClassKey = {
    [P in keyof MuiPickersOverrides]: keyof MuiPickersOverrides[P];
};

type pickerAndAutocompleteOverrides = overridesNameToClassKey & {
    MuiAutocomplete: any;
    MuiToggleButton: any;
    MuiPaginationItem: any;
    MuiToggleButtonGroup: any;
};

declare module "@material-ui/core/styles/overrides" {
    export interface ComponentNameToClassKey extends pickerAndAutocompleteOverrides {}
}

class ThemeStore {
    @observable THEME: Theme = aaaTheme;
    @observable GlobalCSS = aaaGlobalCSS;
    @observable Images = aaaImages;
    @persist @observable THEME_MODE: "light" | "dark" = "light";
    @persist @observable THEME_NAME: "aaa" | "dal" = "aaa";
    @observable customColors = aaaCustomColors;

    @action toggleBranding = () => {
        if (this.THEME_NAME === "aaa") {
            if (this.THEME_MODE === "light") {
                this.THEME = dalTheme;
                this.Images = dalImages;
                this.GlobalCSS = dalGlobalCSS;
                this.customColors = dalCustomColors;
                this.THEME_NAME = "dal";
            } else if (this.THEME_MODE === "dark") {
                this.THEME = dalThemeDark;
                this.Images = dalImagesDark;
                this.GlobalCSS = dalGlobalCSSDark;
                this.customColors = dalCustomColorsDark;
                this.THEME_NAME = "dal";
            }
        } else if (this.THEME_NAME === "dal") {
            if (this.THEME_MODE === "light") {
                this.THEME = aaaTheme;
                this.Images = aaaImages;
                this.GlobalCSS = aaaGlobalCSS;
                this.customColors = aaaCustomColors;
                this.THEME_NAME = "aaa";
            } else if (this.THEME_MODE === "dark") {
                this.THEME = aaaThemeDark;
                this.Images = aaaImagesDark;
                this.GlobalCSS = aaaGlobalCSSDark;
                this.customColors = aaaCustomColorsDark;
                this.THEME_NAME = "aaa";
            }
        }
    };

    @action toggleMode = () => {
        if (this.THEME_NAME === "aaa") {
            if (this.THEME_MODE === "light") {
                this.THEME = aaaThemeDark;
                this.Images = aaaImagesDark;
                this.GlobalCSS = aaaGlobalCSSDark;
                this.customColors = aaaCustomColorsDark;
                this.THEME_MODE = "dark";
            } else if (this.THEME_MODE === "dark") {
                this.THEME = aaaTheme;
                this.Images = aaaImages;
                this.GlobalCSS = aaaGlobalCSS;
                this.customColors = aaaCustomColors;
                this.THEME_MODE = "light";
            }
        } else if (this.THEME_NAME === "dal") {
            if (this.THEME_MODE === "light") {
                this.THEME = dalThemeDark;
                this.Images = dalImagesDark;
                this.GlobalCSS = dalGlobalCSSDark;
                this.customColors = dalCustomColorsDark;
                this.THEME_MODE = "dark";
            } else if (this.THEME_MODE === "dark") {
                this.THEME = dalTheme;
                this.Images = dalImages;
                this.GlobalCSS = dalGlobalCSS;
                this.customColors = dalCustomColors;
                this.THEME_MODE = "light";
            }
        }
    };
}
const hydrate = create({
    storage: require("localforage")
});

export const THEME = new ThemeStore();
hydrate("theme", THEME).then(() => {
    if (THEME.THEME_NAME === "aaa") {
        if (THEME.THEME_MODE === "light") {
            THEME.THEME = aaaTheme;
            THEME.Images = aaaImages;
            THEME.GlobalCSS = aaaGlobalCSS;
            THEME.customColors = aaaCustomColors;
        } else if (THEME.THEME_MODE === "dark") {
            THEME.THEME = aaaThemeDark;
            THEME.Images = aaaImagesDark;
            THEME.GlobalCSS = aaaGlobalCSSDark;
            THEME.customColors = aaaCustomColorsDark;
        }
    } else if (THEME.THEME_NAME === "dal") {
        if (THEME.THEME_MODE === "light") {
            THEME.THEME = dalTheme;
            THEME.Images = dalImages;
            THEME.GlobalCSS = dalGlobalCSS;
            THEME.customColors = dalCustomColors;
        } else if (THEME.THEME_MODE === "dark") {
            THEME.THEME = dalThemeDark;
            THEME.Images = dalImagesDark;
            THEME.GlobalCSS = dalGlobalCSSDark;
            THEME.customColors = dalCustomColorsDark;
        }
    }
});

export const isDal = () => THEME.THEME_NAME === "dal";
export const isDarkMode = () => THEME.THEME_MODE === "dark";
